import { InputPostalCode } from "@/components/Input/PostalCode/InputPostalCode";
import { SupportedCountry } from "@/constants/country";

import {
  CFormItemBase,
  type CFormItemProps,
  buildCFormItem,
} from "../CFormItem";

type Props = CFormItemProps & {
  value?: string;
  onChange: (value?: string) => void;
  /** 国コード（デフォルト: JP） */
  countryCode?: SupportedCountry;
};

/**
 * Card-based Form / PostalCodeItem
 *
 * 郵便番号入力用のCFormアイテム。
 * 国コードに応じたフォーマット（日本の場合は xxx-xxxx）を適用します。
 */
export const CFormPostalCodeItem = buildCFormItem((props: Props) => {
  const countryCode = props.countryCode ?? SupportedCountry.JP;

  return (
    <CFormItemBase
      {...props}
      readComponent={props.value}
      writeComponent={
        <InputPostalCode
          countryCode={countryCode}
          value={props.value ?? ""}
          onValueChange={(value) => props.onChange(value || undefined)}
        />
      }
    />
  );
});
